import { CompareFunction, OrderDirection, StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementCompareChange extends StoryElementBase {
	type = StoryElementType.COMPARE_CHANGE;

	override get isLoading(): boolean {
		return super.isLoading || !this.dataRoot;
	}

	get longTitle(): string {
		const compare = this.compare,
			unit = compare?.function === CompareFunction.ABSOLUTE ? 'change' : '%';

		return compare?.isGoal ? `Goal ${unit}` : `Comparison ${unit}`;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		node.classList.toggle('loading', this.isDataIncomplete);

		let text = '';

		const comparePoint = this.comparePoint,
			changeStr = this.comparePoint?.changeStr;

		if (comparePoint && changeStr) {
			// if we have the indicator, remove it (keep any format prefix, e.g. a currency)
			text = changeStr.replace(/^[\u25B2\u25BC]\s*/, '');

			if (!this.compare?.isGoal) {
				text += ' ';

				const changeArrowDirection = comparePoint.arrowDirection,
					indicatorClass = comparePoint.indicatorClass;
				if (changeArrowDirection && indicatorClass) {
					let changeArrowText = '▲';

					if (changeArrowDirection === OrderDirection.DESC) {
						changeArrowText = '▼';
						text += 'decrease';
					} else {
						text += 'increase';
					}

					const indicatorElement = document.createElement('span');
					indicatorElement.classList.add('indicator', indicatorClass);
					indicatorElement.textContent = changeArrowText;
					node.append(indicatorElement);
				} else {
					text += 'change';
				}
			}
		} else {
			text = '-';
		}

		node.append(text);
	}
}
